import { TopPopupContainer } from '../top_popup/container';
import * as React from 'react';
import { Link } from '@cian/components';
import * as styles from './index.css';

export interface IHideOfferTopPupupProps {
  isError: boolean;
  lkUrl: string;
  errorMessage: string;
}

export const HideOfferTopPopup: React.StatelessComponent<IHideOfferTopPupupProps> = props => {
  const { isError, lkUrl, errorMessage } = props;

  return (
    <TopPopupContainer isError={isError}>
      {isError ? (
        errorMessage
      ) : (
        <>
          Объявление скрыто из результатов поиска. Вы можете восстановить объявление в{' '}
          <Link href={lkUrl} target="_blank" linkStyle={styles['popup-link']}>
            личном кабинете
          </Link>
        </>
      )}
    </TopPopupContainer>
  );
};
